import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { IJsonObject } from 'dcerialize';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ApiService } from './api.service';

export interface ProgressReportResponse {
  url: string;
}

export interface LmsWithProgressReport {
  url: string;
}

export interface ListLmsWithProgressReportResponse {
  items: LmsWithProgressReport[];
  total: number;
}

@Injectable({
  providedIn: 'root'
})
export class LmsService {
  private http = inject(HttpClient);
  private apiService = inject(ApiService);

  path = '/lms';
  pathV2 = '/v2/lms';

  lmsUrlsWithProgressReport = signal<string[]>([]);

  constructor() {
    this.path = this.apiService.getApiUrl() + this.path;
    this.pathV2 = this.apiService.getApiUrl() + this.pathV2;
  }

  /**
   * Get the list of LMS URLs that have progress report enabled
   *
   * @returns List of LMS with progress report
   */
  listLmsWithProgressReport(): Observable<ListLmsWithProgressReportResponse> {
    return this.http.get<ListLmsWithProgressReportResponse>(`${this.path}/with-progress-report`).pipe(
      tap((response) => {
        this.lmsUrlsWithProgressReport.set(response.items.map((item) => item.url));
      })
    );
  }

  /**
   * Check if the LMS related to a course can access moodle
   *
   * @param courseId Id of the course related to the LMS to check
   * @returns Whether the LMS has access
   */
  checkLmsAccess(courseId: number): Observable<boolean> {
    return this.http.get<IJsonObject>(`${this.pathV2}/${courseId}/has-access`).pipe(map((response) => !!response));
  }

  /**
   * Get the progress report URL from Campus
   *
   * @param enrolmentId Id of the enrolment
   * @returns Url of the progress report
   */
  getProgressReportUrl(enrolmentId: string): Observable<ProgressReportResponse> {
    return this.http.get<ProgressReportResponse>(`${this.path}/${enrolmentId}/progress-report`);
  }
}
